/*!
 * devextreme-angular
 * Version: 24.2.7
 * Build date: Mon Apr 28 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import { TextEditorButtonLocation } from 'devextreme/common';
import { dxButtonOptions } from 'devextreme/ui/button';

import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { CollectionNestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxi-date-box-button',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxiDateBoxButtonComponent extends CollectionNestedOption {
    @Input()
    get location(): TextEditorButtonLocation {
        return this._getOption('location');
    }
    set location(value: TextEditorButtonLocation) {
        this._setOption('location', value);
    }

    @Input()
    get name(): string | undefined {
        return this._getOption('name');
    }
    set name(value: string | undefined) {
        this._setOption('name', value);
    }

    @Input()
    get options(): dxButtonOptions | undefined {
        return this._getOption('options');
    }
    set options(value: dxButtonOptions | undefined) {
        this._setOption('options', value);
    }


    protected get _optionPath() {
        return 'buttons';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }



    ngOnDestroy() {
        this._deleteRemovedOptions(this._fullOptionPath());
    }

}

@NgModule({
  declarations: [
    DxiDateBoxButtonComponent
  ],
  exports: [
    DxiDateBoxButtonComponent
  ],
})
export class DxiDateBoxButtonModule { }
